export const isHydroExpired = (date) => {
  if (!date || date === null ) return false;

  const hydroDate = new Date(date);
  const expiryDate = new Date(hydroDate);
  expiryDate.setFullYear(expiryDate.getFullYear() + 2);

  return new Date() > expiryDate;
};
